// extracted by mini-css-extract-plugin
module.exports = {"maxWidthLg":"Modal_maxWidthLg__hSkkI","notFull":"Modal_notFull__Aq0vR"};